import * as React from 'react';
import { BulkExportService } from '../services/BulkExportService2';
import { BulkExportContextReact, BulkExportServiceContextReact, defaultBulkExportContext } from '../BulkExportContextReact';

export type BulkExportProviderProps = {
  service: BulkExportService;
}

export const BulkExportProvider: React.FC<BulkExportProviderProps> = props => {
  if (!props.service.hasBulkExportContext) {
    props.service.bulkExportContext = defaultBulkExportContext;
  }
  return (<BulkExportContextReact.Provider value={defaultBulkExportContext}>
    <BulkExportServiceContextReact.Provider value={props.service}>
      {props.children}
    </BulkExportServiceContextReact.Provider>
  </BulkExportContextReact.Provider>);
}